import React, { useState, useEffect } from "react";
import NewFooter from "../Footer/NewFooter";
import { HiX } from "react-icons/hi";
import { GrDownload } from "react-icons/gr";

const OurSpaces = () => {
  const [open, setOpen] = useState(false);

  const [animateClose, setAnimateClose] = useState(false);
  const [isBlocked] = useState(false);

  const rooms = [
    {
      name: "Living Room",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/c19cae04-a902-473f-9f03-7fe5eb59b800/public", // Tao_ourSpaces_newLiving.jpg
      desc: [
        "This space is designed for pause.",
        "For conversation.",
        "For silence.",
        "For everything in between.",
      ],
    },
    {
      name: "Dining Room",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/8ce8179d-6eca-4766-9cf4-63dbcaa62d00/public", // Tao_ourSpaces_newDining.jpg
      desc: [
        "A calm dining space filled with natural light.",
        "Perfect for long meals and warm conversations.",
        "Minimal yet comforting.",
      ],
    },
    {
      name: "Bedroom 01",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/aa723952-989d-4548-c9d5-a815aac08b00/public", // Tao_ourSpaces_newBedroom1.jpg
      desc: [
        "Soft lighting, neutral tones and warm textures.",
        "A space created for deep rest and slow mornings.",
      ],
    },
    {
      name: "Bedroom 02",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/2982dc26-74b3-4c5e-09d0-197820c56900/public", // Tao_ourSpaces_newBedroom2.jpg
      desc: [
        "A cozy bedroom with gentle natural tones.",
        "Designed for peaceful, restorative sleep.",
      ],
    },
    {
      name: "Bedroom 03",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/2803925f-945c-4599-745e-8c756ea0e200/public", // Tao_ourSpaces_newBedroom3.jpg
      desc: [
        "Warm wooden elements meet soft fabric textures.",
        "Relaxation at its purest.",
      ],
    },
    {
      name: "Bedroom 04",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5a85d885-a339-4240-424d-896c6c278100/public", // Tao_ourSpaces_newBedroom4.jpg
      desc: [
        "Bright, comfortable and elegantly simple.",
        "Perfect for unwinding.",
      ],
    },
    {
      name: "Bedroom 05",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/2e4998b8-ec26-42ea-7a1b-3cbe2c240800/public", // Tao_ourSpaces_newBedroom5.jpg
      desc: [
        "A tranquil room with calming aesthetics.",
        "A gentle retreat for the senses.",
      ],
    },
    {
      name: "Courtyard",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/9025491a-419d-4c05-55d3-5cb7d1f0ff00/public", // Tao_ourSpaces_newCourtyard.jpg
      desc: [
        "Open air, greenery, and peace.",
        "Perfect for morning tea or evening quiet moments.",
      ],
    },
    {
      name: "Swimming Pool",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/2db9c618-99b9-4834-9a75-f3e3f9747e00/public", // Tao_ourSpaces_desktop_swimming.webp
      desc: [
        "A refreshing escape surrounded by calming architecture.",
        "Ideal for both morning laps and evening relaxation.",
      ],
    },
  ];

  const mobile = [
    {
      name: "Living Room",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/e1b3c0f2-fea1-4b0a-d10a-83ab5505c500/public", //Tao_ourSpaces_mobile_newLiving.jpg
      desc: [
        "This space is designed for pause.",
        "For conversation.",
        "For silence.",
        "For everything in between.",
      ],
    },
    {
      name: "Dining Room",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/701a08f6-2ff5-45cb-1f1f-db7b1a93d700/public", //Tao_ourSpaces_mobile_newDining.jpg
      desc: [
        "A calm dining space filled with natural light.",
        "Perfect for long meals and warm conversations.",
        "Minimal yet comforting.",
      ],
    },
    {
      name: "Bedroom 01",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/c9ea46b0-8770-4907-7140-747e898ac100/public", //Tao_ourSpaces_room1.webp
      desc: [
        "Soft lighting, neutral tones and warm textures.",
        "A space created for deep rest and slow mornings.",
      ],
    },
    {
      name: "Bedroom 02",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5761633a-dec7-478f-e154-7d785a788200/public", //Tao_ourSpaces_room2.webp
      desc: [
        "A cozy bedroom with gentle natural tones.",
        "Designed for peaceful, restorative sleep.",
      ],
    },
    {
      name: "Bedroom 03",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/8c468345-b247-4a78-3ac6-c2117fd21300/public", //Tao_ourSpaces_room3.webp
      desc: [
        "Warm wooden elements meet soft fabric textures.",
        "Relaxation at its purest.",
      ],
    },
    {
      name: "Bedroom 04",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/b2f61030-8e86-443c-9478-0e17bcd19300/public", //Tao_ourSpaces_room4.webp
      desc: [
        "Bright, comfortable and elegantly simple.",
        "Perfect for unwinding.",
      ],
    },
    {
      name: "Bedroom 05",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/106fc33c-3704-4934-f675-e62657953000/public", //Tao_ourSpaces_room5.webp
      desc: [
        "A tranquil room with calming aesthetics.",
        "A gentle retreat for the senses.",
      ],
    },
    {
      name: "Courtyard",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/69068d74-2a68-4b4a-a6af-db2edd433400/public", //Tao_ourSpaces_court.webp
      desc: [
        "Open air, greenery, and peace.",
        "Perfect for morning tea or evening quiet moments.",
      ],
    },
    {
      name: "Swimming Pool",
      img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/02074fa0-940e-4888-ab53-ffb4c964d500/public", //Tao_swimmingpool.webp
      desc: [
        "A refreshing escape surrounded by calming architecture.",
        "Ideal for both morning laps and evening relaxation.",
      ],
    },
  ];

  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(false);

  const nextRoom = () => {
    setFade(true);
    setTimeout(() => {
      setCurrent((prev) => (prev + 1) % rooms.length);
      setFade(false);
    }, 500);
  };

  const prevRoom = () => {
    setFade(true);
    setTimeout(() => {
      setCurrent((prev) => (prev - 1 + rooms.length) % rooms.length);
      setFade(false);
    }, 500);
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setFade(true);
      setTimeout(() => {
        setCurrent((prev) => (prev + 1) % rooms.length);
        setFade(false);
      }, 500);
    }, 6000);

    return () => clearInterval(timer);
  }, [rooms.length]);

  const handleClose = () => {
    setAnimateClose(true);
    setTimeout(() => {
      setOpen(false);
      setAnimateClose(false);
    }, 500);
  };

  return (
    <>
      <header
        className={`
          h-20 hidden sm:flex items-center w-full transition-all duration-300
          sticky top-0 z-[100]
          ${open ? "bg-[#f5f2f0]" : "bg-transparent"}
        `}
      >
        <div className="flex justify-between items-center w-full px-10 lg:px-20">
          <a href="/HomePage">
            <img src="../assets/Logo2.png" alt="Logo" className="h-12" />
          </a>

          <div className="hidden lg:block ml-auto absolute right-40 top-7">
            <a href="/BookNow" onClick={handleClose}>
              <div
                className="text-[15px] text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp underline underline-offset-4"
                style={{ animationDelay: "0.45s" }}
              >
                Reserve Now!
              </div>
            </a>
          </div>

          {!open ? (
            <button
              onClick={() => !isBlocked && setOpen(true)}
              className="flex flex-col space-y-2.5 absolute right-10 lg:right-20 top-6 opacity-100 pointer-events-auto"
            >
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
            </button>
          ) : (
            <button
              onClick={handleClose}
              className="text-3xl text-[#948A78] absolute right-8 sm:right-10 lg:right-20 top-6 z-[70]"
            >
              <HiX />
            </button>
          )}
        </div>

        {(open || animateClose) && (
          <>
            <div
              onClick={handleClose}
              className={`fixed left-0 top-20 h-[calc(100vh-80px)] w-full
                transition-opacity duration-500 z-[49]
                ${
                  animateClose
                    ? "opacity-0 pointer-events-none"
                    : "opacity-100 pointer-events-auto"
                }`}
            ></div>

            <div
              className={`fixed top-20 right-0 h-[calc(100vh-80px)]
                bg-[#f5f2f0] sm:bg-transparent sm:bg-gradient-to-l sm:from-[#f5f2f0] sm:via-[#f5f2f0]/80 sm:to-transparent
                w-full px-10 py-16 flex flex-col justify-between text-left
                overflow-hidden z-[50]
                ${
                  animateClose
                    ? "animate-menuSlideLeftToRight"
                    : "animate-menuSlideRightToLeft"
                }`}
            >
              <div className="flex justify-end w-full">
                <nav className="flex flex-col text-left text-xl tracking-[0.3em] text-[#948A78] space-y-8 sm:mr-5 lg:mt-5 -mt-8">
                  {["Our Philosophy", "Our Spaces", "Our Services"].map(
                    (item, index) => (
                      <a
                        key={index}
                        href={`/${item.replace(/\s/g, "")}`}
                        onClick={handleClose}
                        className="transform translate-y-20 opacity-0 animate-slideUp"
                        style={{ animationDelay: `${index * 0.25}s` }}
                      >
                        {item}
                      </a>
                    )
                  )}

                  <div
                    className="flex items-center space-x-2 transform translate-y-20 opacity-0 animate-slideUp cursor-pointer"
                    style={{ animationDelay: "0.8s" }}
                  >
                    <a
                      href="../assets/House_of_Tao.pdf"
                      target="_blank"
                      onClick={handleClose}
                      className="text-[#948A78] text-xl tracking-[0.3em] flex items-center xl:mt-60 lg:mt-44 lg:ml-3"
                    >
                      <GrDownload className="mr-3" /> Brochure
                    </a>
                  </div>
                </nav>
              </div>

              <div className="flex justify-center mb-10 lg:hidden">
                <a
                  href="/BookNow"
                  onClick={handleClose}
                  className="text-xl text-[#4F423B] tracking-[0.3em] transform translate-y-20 opacity-0 animate-slideUp sm:ml-[70vh] ml-7 underline underline-offset-4"
                  style={{ animationDelay: "0.85s" }}
                >
                  Reserve Now!
                </a>
              </div>
            </div>
          </>
        )}

        <style jsx>{`
          @keyframes slideUp {
            0% {
              opacity: 0;
              transform: translateY(50px);
            }
            100% {
              opacity: 1;
              transform: translateY(0);
            }
          }
          .animate-slideUp {
            animation: slideUp 0.85s forwards;
          }
          @keyframes menuSlideRightToLeft {
            0% {
              transform: translateX(100%);
            }
            100% {
              transform: translateX(0);
            }
          }
          .animate-menuSlideRightToLeft {
            animation: menuSlideRightToLeft 0.55s ease forwards;
          }
          @keyframes menuSlideLeftToRight {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(100%);
            }
          }
          .animate-menuSlideLeftToRight {
            animation: menuSlideLeftToRight 0.55s ease forwards;
          }
        `}</style>
      </header>

      <div className="hidden md:block w-full text-[#948A78] text-sm lg:text-base 2xl:text-lg leading-relaxed">
        <div className="pt-[25px]">
          <div className="mx-5 lg:mx-10 grid grid-cols-1 md:grid-cols-[65%_30%] lg:grid-cols-[60%_35%] gap-2 sm:gap-[5%] items-center">
            <div className="flex items-center gap-3">
              <button onClick={prevRoom} className="cursor-pointer">
                <div className="flex items-center rotate-180">
                  <div className="h-[1px] w-4 lg:w-[5vw] 2xl:w-28 bg-[#948A78]" />
                  <div className="relative w-3 h-3 -ml-1">
                    <div className="absolute w-2 h-[1px] bg-[#948A78] rotate-45 origin-left top-0" />
                    <div className="absolute w-2 h-[1px] bg-[#948A78] -rotate-45 origin-left bottom-0" />
                  </div>
                </div>
              </button>

              <div>
                <img
                  src={rooms[current].img}
                  alt={rooms[current].name}
                  className={`h-[30vh] md:h-[50vh] xl:h-[60vh] w-full object-cover object-bottom transition-opacity duration-[1000ms] ease-in-out ${
                    fade ? "opacity-0" : "opacity-100"
                  }`}
                />

                <div className="text-xs md:text-sm 2xl:text-lg max-w-[600px] space-y-3 mt-5">
                  {rooms[current].desc.map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              </div>

              <button onClick={nextRoom} className="cursor-pointer">
                <div className="flex items-center">
                  <div className="h-[1px] w-4 lg:w-[5vw] 2xl:w-28 bg-[#948A78]" />
                  <div className="relative w-3 h-3 -ml-1">
                    <div className="absolute w-2 h-[1px] bg-[#948A78] rotate-45 origin-left top-0" />
                    <div className="absolute w-2 h-[1px] bg-[#948A78] -rotate-45 origin-left bottom-0" />
                  </div>
                </div>
              </button>
            </div>

            <div className="max-h-[80vh] overflow-y-auto py-5">
              <div className="flex flex-row md:flex-col gap-3 items-end">
                {rooms.map((room, i) => (
                  <div
                    key={i}
                    className="flex flex-col md:flex-row items-start sm:gap-5 cursor-pointer"
                    onClick={() => setCurrent(i)}
                  >
                    <p
                      className={`text-xs md:text-sm 2xl:text-lg transition-all duration-300 ${
                        current === i ? "opacity-100" : "opacity-40"
                      }`}
                    >
                      {room.name}
                    </p>

                    <div className="relative">
                      <img
                        src={room.img}
                        alt={room.name}
                        className={`h-[12vh] w-[10vw] md:min-w-[140px] min-w-[200px] object-cover transition-all duration-300 ${
                          current === i ? "opacity-100" : "opacity-40"
                        }`}
                      />
                      {current !== i && (
                        <div className="absolute inset-0 bg-white/30 backdrop-blur-[1px]"></div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MOBILE */}
      <div className="block sm:hidden w-full text-[#948A78] text-sm leading-relaxed">
        <header
          className={`fixed top-0 left-0 w-full h-20 flex items-center justify-between px-6 z-[60] md:hidden transition-colors duration-500
                ${open ? "bg-[#f5f2f0]" : "bg-transparent"}`}
        >
          <a href="/HomePage">
            <img src="../assets/Logo2.png" alt="Logo" className="h-12" />
          </a>

          {!open ? (
            <button
              onClick={() => setOpen(true)}
              className="flex flex-col space-y-2.5"
            >
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
              <span className="w-8 h-[2px] bg-[#948A78]"></span>
            </button>
          ) : (
            <button
              onClick={() => setOpen(false)}
              className="text-3xl text-[#948A78]"
            >
              <HiX />
            </button>
          )}
        </header>

        {open && (
          <div
            className="fixed top-20 left-0 w-full h-[calc(100vh-80px)] z-[50]"
            onClick={() => setOpen(false)}
          ></div>
        )}

        <div
          className={`fixed top-20 right-0 h-[calc(100vh-80px)] bg-[#f5f2f0] w-full px-10 py-16 
              flex flex-col items-center justify-between z-[55] transform transition-transform duration-500
              ${open ? "translate-x-0" : "translate-x-full"}`}
        >
          <nav className="flex flex-col items-start text-left ml-14 text-xl tracking-[0.3em] text-[#948A78] space-y-8">
            <a
              href="/OurPhilosophy"
              onClick={() => setOpen(false)}
              className={`transition-all duration-700 ${
                open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: "200ms" }}
            >
              Our&nbsp;Philosophy
            </a>

            <a
              href="/OurSpaces"
              onClick={() => setOpen(false)}
              className={`transition-all duration-700 ${
                open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: "350ms" }}
            >
              Our&nbsp;Spaces
            </a>

            <a
              href="/OurServices"
              onClick={() => setOpen(false)}
              className={`transition-all duration-700 ${
                open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
              }`}
              style={{ transitionDelay: "500ms" }}
            >
              Our&nbsp;Services
            </a>

            <a
              href="../assets/House_of_Tao.pdf"
              target="_blank"
              onClick={() => setOpen(false)}
              className={`flex justify-end items-center text-xl tracking-[0.3em] transition-all duration-700
                  ${
                    open
                      ? "opacity-100 translate-y-0"
                      : "opacity-0 translate-y-6"
                  }`}
              style={{ transitionDelay: "650ms" }}
            >
              <GrDownload className="mr-3" /> Brochure
            </a>
          </nav>

          <a
            href="/BookNow"
            onClick={() => setOpen(false)}
            className={`text-xl text-[#4F423B] tracking-[0.3em] transition-all duration-700 underline underline-offset-4
                ${
                  open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
                }`}
            style={{ transitionDelay: "800ms" }}
          >
            Reserve Now!
          </a>
        </div>

        <div className="pb-12 px-8">
          <div className="flex items-center justify-between mt-20 mb-5 px-4  gap-6">
            <h2 className="text-lg text-right">
              Our <br /> Spaces
            </h2>

            <a
              href="../assets/House_of_Tao.pdf"
              target="_blank"
              className="flex items-center text-[#948A78] uppercase underline underline-offset-4 cursor-pointer text-[14px]"
            >
              Download&nbsp;Brochure
            </a>
          </div>

          <div className="relative flex items-center justify-center w-full">
            <button
              onClick={() => {
                setFade(true);
                setTimeout(() => {
                  setCurrent(
                    (prev) => (prev - 1 + mobile.length) % mobile.length
                  );
                  setFade(false);
                }, 300);
              }}
              className="absolute left-[-30px] top-1/2 transform -translate-y-1/2 z-20 p-2"
            >
              <div className="flex items-center rotate-180">
                <div className="h-[1px] w-5 bg-[#948A78]" />
                <div className="relative w-3 h-3 -ml-1">
                  <div className="absolute w-2 h-[1px] bg-[#948A78] rotate-45 origin-left top-0" />
                  <div className="absolute w-2 h-[1px] bg-[#948A78] -rotate-45 origin-left bottom-0" />
                </div>
              </div>
            </button>

            {/* Image */}
            <div className="w-full max-w-[70vw] mx-auto">
              <img
                src={mobile[current].img}
                alt={mobile[current].name}
                className={`w-full h-[65vh] object-cover transition-opacity duration-500 ease-in-out ${
                  fade ? "opacity-0" : "opacity-100"
                }`}
              />

              <div className="mt-3 text-left">
                <h3 className="text-[13px] tracking-[0.3em]">
                  {mobile[current].name}
                </h3>
                <div className="text-xs mt-2 space-y-2">
                  {mobile[current].desc.map((line, index) => (
                    <p key={index}>{line}</p>
                  ))}
                </div>
              </div>
            </div>

            <button
              onClick={() => {
                setFade(true);
                setTimeout(() => {
                  setCurrent((prev) => (prev + 1) % mobile.length);
                  setFade(false);
                }, 300);
              }}
              className="absolute right-[-30px] top-1/2 transform -translate-y-1/2 z-20 p-2"
            >
              <div className="flex items-center">
                <div className="h-[1px] w-5 bg-[#948A78]" />
                <div className="relative w-3 h-3 -ml-1">
                  <div className="absolute w-2 h-[1px] bg-[#948A78] rotate-45 origin-left top-0" />
                  <div className="absolute w-2 h-[1px] bg-[#948A78] -rotate-45 origin-left bottom-0" />
                </div>
              </div>
            </button>
          </div>
        </div>

        <NewFooter />
      </div>
    </>
  );
};

export default OurSpaces;

// import React, { useState, useEffect } from "react";
// import NewHeader from "../Header/NewHeader";
// import NewFooter from "../Footer/NewFooter";
// import { HiX } from "react-icons/hi";
// import { GrDownload } from "react-icons/gr";

// const OurSpaces = () => {
//   const [open, setOpen] = useState(false);

//   const rooms = [
//     {
//       name: "Living Room",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/c19cae04-a902-473f-9f03-7fe5eb59b800/public", // Tao_ourSpaces_newLiving.jpg
//       desc: [
//         "This space is designed for pause.",
//         "For conversation.",
//         "For silence.",
//         "For everything in between.",
//       ],
//     },
//     {
//       name: "Dining Room",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/8ce8179d-6eca-4766-9cf4-63dbcaa62d00/public", // Tao_ourSpaces_newDining.jpg
//       desc: [
//         "A calm dining space filled with natural light.",
//         "Perfect for long meals and warm conversations.",
//         "Minimal yet comforting.",
//       ],
//     },
//     {
//       name: "Bedroom 01",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/aa723952-989d-4548-c9d5-a815aac08b00/public", // Tao_ourSpaces_newBedroom1.jpg
//       desc: [
//         "Soft lighting, neutral tones and warm textures.",
//         "A space created for deep rest and slow mornings.",
//       ],
//     },
//     {
//       name: "Bedroom 02",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/2982dc26-74b3-4c5e-09d0-197820c56900/public", // Tao_ourSpaces_newBedroom2.jpg
//       desc: [
//         "A cozy bedroom with gentle natural tones.",
//         "Designed for peaceful, restorative sleep.",
//       ],
//     },
//     {
//       name: "Bedroom 03",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/2803925f-945c-4599-745e-8c756ea0e200/public", // Tao_ourSpaces_newBedroom3.jpg
//       desc: [
//         "Warm wooden elements meet soft fabric textures.",
//         "Relaxation at its purest.",
//       ],
//     },
//     {
//       name: "Bedroom 04",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5a85d885-a339-4240-424d-896c6c278100/public", // Tao_ourSpaces_newBedroom4.jpg
//       desc: [
//         "Bright, comfortable and elegantly simple.",
//         "Perfect for unwinding.",
//       ],
//     },
//     {
//       name: "Bedroom 05",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/2e4998b8-ec26-42ea-7a1b-3cbe2c240800/public", // Tao_ourSpaces_newBedroom5.jpg
//       desc: [
//         "A tranquil room with calming aesthetics.",
//         "A gentle retreat for the senses.",
//       ],
//     },
//     {
//       name: "Courtyard",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/9025491a-419d-4c05-55d3-5cb7d1f0ff00/public", // Tao_ourSpaces_newCourtyard.jpg
//       desc: [
//         "Open air, greenery, and peace.",
//         "Perfect for morning tea or evening quiet moments.",
//       ],
//     },
//     {
//       name: "Swimming Pool",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/2db9c618-99b9-4834-9a75-f3e3f9747e00/public", // Tao_ourSpaces_desktop_swimming.webp
//       desc: [
//         "A refreshing escape surrounded by calming architecture.",
//         "Ideal for both morning laps and evening relaxation.",
//       ],
//     },
//   ];

//   const mobile = [
//     {
//       name: "Living Room",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/e1b3c0f2-fea1-4b0a-d10a-83ab5505c500/public", //Tao_ourSpaces_mobile_newLiving.jpg
//       desc: [
//         "This space is designed for pause.",
//         "For conversation.",
//         "For silence.",
//         "For everything in between.",
//       ],
//     },
//     {
//       name: "Dining Room",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/701a08f6-2ff5-45cb-1f1f-db7b1a93d700/public", //Tao_ourSpaces_mobile_newDining.jpg
//       desc: [
//         "A calm dining space filled with natural light.",
//         "Perfect for long meals and warm conversations.",
//         "Minimal yet comforting.",
//       ],
//     },
//     {
//       name: "Bedroom 01",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/c9ea46b0-8770-4907-7140-747e898ac100/public", //Tao_ourSpaces_room1.webp
//       desc: [
//         "Soft lighting, neutral tones and warm textures.",
//         "A space created for deep rest and slow mornings.",
//       ],
//     },
//     {
//       name: "Bedroom 02",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/5761633a-dec7-478f-e154-7d785a788200/public", //Tao_ourSpaces_room2.webp
//       desc: [
//         "A cozy bedroom with gentle natural tones.",
//         "Designed for peaceful, restorative sleep.",
//       ],
//     },
//     {
//       name: "Bedroom 03",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/8c468345-b247-4a78-3ac6-c2117fd21300/public", //Tao_ourSpaces_room3.webp
//       desc: [
//         "Warm wooden elements meet soft fabric textures.",
//         "Relaxation at its purest.",
//       ],
//     },
//     {
//       name: "Bedroom 04",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/b2f61030-8e86-443c-9478-0e17bcd19300/public", //Tao_ourSpaces_room4.webp
//       desc: [
//         "Bright, comfortable and elegantly simple.",
//         "Perfect for unwinding.",
//       ],
//     },
//     {
//       name: "Bedroom 05",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/106fc33c-3704-4934-f675-e62657953000/public", //Tao_ourSpaces_room5.webp
//       desc: [
//         "A tranquil room with calming aesthetics.",
//         "A gentle retreat for the senses.",
//       ],
//     },
//     {
//       name: "Courtyard",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/69068d74-2a68-4b4a-a6af-db2edd433400/public", //Tao_ourSpaces_court.webp
//       desc: [
//         "Open air, greenery, and peace.",
//         "Perfect for morning tea or evening quiet moments.",
//       ],
//     },
//     {
//       name: "Swimming Pool",
//       img: "https://imagedelivery.net/1KyJN6DqRSgEbKUMt_Oskw/02074fa0-940e-4888-ab53-ffb4c964d500/public", //Tao_swimmingpool.webp
//       desc: [
//         "A refreshing escape surrounded by calming architecture.",
//         "Ideal for both morning laps and evening relaxation.",
//       ],
//     },
//   ];

//   const [current, setCurrent] = useState(0);
//   const [fade, setFade] = useState(false);

//   const nextRoom = () => {
//     setFade(true);
//     setTimeout(() => {
//       setCurrent((prev) => (prev + 1) % rooms.length);
//       setFade(false);
//     }, 500);
//   };

//   const prevRoom = () => {
//     setFade(true);
//     setTimeout(() => {
//       setCurrent((prev) => (prev - 1 + rooms.length) % rooms.length);
//       setFade(false);
//     }, 500);
//   };

//   useEffect(() => {
//     const timer = setInterval(() => {
//       setFade(true);
//       setTimeout(() => {
//         setCurrent((prev) => (prev + 1) % rooms.length);
//         setFade(false);
//       }, 500);
//     }, 6000);

//     return () => clearInterval(timer);
//   }, [rooms.length]);

//   return (
//     <>
//       {/* DESKTOP */}
//       <div className="hidden md:block w-full text-[#948A78] text-sm lg:text-base 2xl:text-lg leading-relaxed">
//         <NewHeader />

//         <div className="pt-[25px]">
//           <div className="mx-5 lg:mx-10 grid grid-cols-1 md:grid-cols-[65%_30%] lg:grid-cols-[60%_35%] gap-2 sm:gap-[5%] items-center">
//             <div className="flex items-center gap-3">
//               <button onClick={prevRoom} className="cursor-pointer">
//                 <div className="flex items-center rotate-180">
//                   <div className="h-[1px] w-4 lg:w-[5vw] 2xl:w-28 bg-[#948A78]" />
//                   <div className="relative w-3 h-3 -ml-1">
//                     <div className="absolute w-2 h-[1px] bg-[#948A78] rotate-45 origin-left top-0" />
//                     <div className="absolute w-2 h-[1px] bg-[#948A78] -rotate-45 origin-left bottom-0" />
//                   </div>
//                 </div>
//               </button>

//               <div>
//                 <img
//                   src={rooms[current].img}
//                   alt={rooms[current].name}
//                   className={`h-[30vh] md:h-[50vh] xl:h-[60vh] w-full object-cover object-bottom transition-opacity duration-[1000ms] ease-in-out ${
//                     fade ? "opacity-0" : "opacity-100"
//                   }`}
//                 />

//                 <div className="text-xs md:text-sm 2xl:text-lg max-w-[600px] space-y-3 mt-5">
//                   {rooms[current].desc.map((line, index) => (
//                     <p key={index}>{line}</p>
//                   ))}
//                 </div>
//               </div>

//               <button onClick={nextRoom} className="cursor-pointer">
//                 <div className="flex items-center">
//                   <div className="h-[1px] w-4 lg:w-[5vw] 2xl:w-28 bg-[#948A78]" />
//                   <div className="relative w-3 h-3 -ml-1">
//                     <div className="absolute w-2 h-[1px] bg-[#948A78] rotate-45 origin-left top-0" />
//                     <div className="absolute w-2 h-[1px] bg-[#948A78] -rotate-45 origin-left bottom-0" />
//                   </div>
//                 </div>
//               </button>
//             </div>

//             <div className="max-h-[80vh] overflow-y-auto py-5">
//               <div className="flex flex-row md:flex-col gap-3 items-end">
//                 {rooms.map((room, i) => (
//                   <div
//                     key={i}
//                     className="flex flex-col md:flex-row items-start sm:gap-5 cursor-pointer"
//                     onClick={() => setCurrent(i)}
//                   >
//                     <p
//                       className={`text-xs md:text-sm 2xl:text-lg transition-all duration-300 ${
//                         current === i ? "opacity-100" : "opacity-40"
//                       }`}
//                     >
//                       {room.name}
//                     </p>

//                     <div className="relative">
//                       <img
//                         src={room.img}
//                         alt={room.name}
//                         className={`h-[12vh] w-[10vw] md:min-w-[140px] min-w-[200px] object-cover transition-all duration-300 ${
//                           current === i ? "opacity-100" : "opacity-40"
//                         }`}
//                       />
//                       {current !== i && (
//                         <div className="absolute inset-0 bg-white/30 backdrop-blur-[1px]"></div>
//                       )}
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* MOBILE */}
//       <div className="block md:hidden w-full text-[#948A78] text-sm leading-relaxed">
//         {/* HEADER */}
//         <header
//           className={`fixed top-0 left-0 w-full h-20 flex items-center justify-between px-6 z-[60] md:hidden transition-colors duration-500
//                 ${open ? "bg-[#f5f2f0]" : "bg-transparent"}`}
//         >
//           <a href="/HomePage">
//             <img src="../assets/Logo2.png" alt="Logo" className="h-12" />
//           </a>

//           {!open ? (
//             <button
//               onClick={() => setOpen(true)}
//               className="flex flex-col space-y-2.5"
//             >
//               <span className="w-8 h-[2px] bg-[#948A78]"></span>
//               <span className="w-8 h-[2px] bg-[#948A78]"></span>
//               <span className="w-8 h-[2px] bg-[#948A78]"></span>
//             </button>
//           ) : (
//             <button
//               onClick={() => setOpen(false)}
//               className="text-3xl text-[#948A78]"
//             >
//               <HiX />
//             </button>
//           )}
//         </header>

//         {open && (
//           <div
//             className="fixed top-20 left-0 w-full h-[calc(100vh-80px)] z-[50]"
//             onClick={() => setOpen(false)}
//           ></div>
//         )}

//         <div
//           className={`fixed top-20 right-0 h-[calc(100vh-80px)] bg-[#f5f2f0] w-full px-10 py-16
//               flex flex-col items-center justify-between z-[55] transform transition-transform duration-500
//               ${open ? "translate-x-0" : "translate-x-full"}`}
//         >
//           {/* NAVIGATION */}
//           <nav className="flex flex-col items-start text-left ml-14 text-xl tracking-[0.3em] text-[#948A78] space-y-8">
//             <a
//               href="/OurPhilosophy"
//               onClick={() => setOpen(false)}
//               className={`transition-all duration-700 ${
//                 open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
//               }`}
//               style={{ transitionDelay: "200ms" }}
//             >
//               Our&nbsp;Philosophy
//             </a>

//             <a
//               href="/OurSpaces"
//               onClick={() => setOpen(false)}
//               className={`transition-all duration-700 ${
//                 open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
//               }`}
//               style={{ transitionDelay: "350ms" }}
//             >
//               Our&nbsp;Spaces
//             </a>

//             <a
//               href="/OurServices"
//               onClick={() => setOpen(false)}
//               className={`transition-all duration-700 ${
//                 open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
//               }`}
//               style={{ transitionDelay: "500ms" }}
//             >
//               Our&nbsp;Services
//             </a>

//             <a
//               href="../assets/House_of_Tao.pdf"
//               target="_blank"
//               onClick={() => setOpen(false)}
//               className={`flex justify-end items-center text-xl tracking-[0.3em] transition-all duration-700
//                   ${
//                     open
//                       ? "opacity-100 translate-y-0"
//                       : "opacity-0 translate-y-6"
//                   }`}
//               style={{ transitionDelay: "650ms" }}
//             >
//               <GrDownload className="mr-3" /> Brochure
//             </a>
//           </nav>

//           <a
//             href="/BookNow"
//             onClick={() => setOpen(false)}
//             className={`text-xl text-[#4F423B] tracking-[0.3em] transition-all duration-700 underline underline-offset-4
//                 ${
//                   open ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
//                 }`}
//             style={{ transitionDelay: "800ms" }}
//           >
//             Reserve Now!
//           </a>
//         </div>

//         <div className="pt-5 pb-12 px-8">
//           <div className="flex items-center justify-between mt-20 mb-5 px-4  gap-6">
//             <h2 className="text-lg text-right">
//               Our <br /> Spaces
//             </h2>

//             <a
//               href="../assets/House_of_Tao.pdf"
//               target="_blank"
//               className="flex items-center text-[#948A78] uppercase underline underline-offset-4 cursor-pointer text-[14px]"
//             >
//               Download&nbsp;Brochure
//             </a>
//           </div>

//           <div className="relative flex items-center justify-center w-full">
//             <button
//               onClick={() => {
//                 setFade(true);
//                 setTimeout(() => {
//                   setCurrent(
//                     (prev) => (prev - 1 + mobile.length) % mobile.length
//                   );
//                   setFade(false);
//                 }, 300);
//               }}
//               className="absolute left-[-30px] top-1/2 transform -translate-y-1/2 z-20 p-2"
//             >
//               <div className="flex items-center rotate-180">
//                 <div className="h-[1px] w-5 bg-[#948A78]" />
//                 <div className="relative w-3 h-3 -ml-1">
//                   <div className="absolute w-2 h-[1px] bg-[#948A78] rotate-45 origin-left top-0" />
//                   <div className="absolute w-2 h-[1px] bg-[#948A78] -rotate-45 origin-left bottom-0" />
//                 </div>
//               </div>
//             </button>

//             {/* Image */}
//             <div className="w-full max-w-[70vw] mx-auto">
//               <img
//                 src={mobile[current].img}
//                 alt={mobile[current].name}
//                 className={`w-full h-[65vh] object-cover transition-opacity duration-500 ease-in-out ${
//                   fade ? "opacity-0" : "opacity-100"
//                 }`}
//               />

//               <div className="mt-3 text-left">
//                 <h3 className="text-[13px] tracking-[0.3em]">
//                   {mobile[current].name}
//                 </h3>
//                 <div className="text-xs mt-2 space-y-2">
//                   {mobile[current].desc.map((line, index) => (
//                     <p key={index}>{line}</p>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             <button
//               onClick={() => {
//                 setFade(true);
//                 setTimeout(() => {
//                   setCurrent((prev) => (prev + 1) % mobile.length);
//                   setFade(false);
//                 }, 300);
//               }}
//               className="absolute right-[-30px] top-1/2 transform -translate-y-1/2 z-20 p-2"
//             >
//               <div className="flex items-center">
//                 <div className="h-[1px] w-5 bg-[#948A78]" />
//                 <div className="relative w-3 h-3 -ml-1">
//                   <div className="absolute w-2 h-[1px] bg-[#948A78] rotate-45 origin-left top-0" />
//                   <div className="absolute w-2 h-[1px] bg-[#948A78] -rotate-45 origin-left bottom-0" />
//                 </div>
//               </div>
//             </button>
//           </div>
//         </div>

//         <NewFooter />
//       </div>
//     </>
//   );
// };

// export default OurSpaces;
